import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onMounted } from "vue";
import { OverworkFlowDat } from "@/models/transaction/OverworkFlowDat";
import { VRow, VCol, VSelect } from "vuetify/lib";
import { InputRules } from "@/rules";
import TimePicker2 from "../TimePicker2.vue";
import {
  PulldownResponse,
  codeKbnFilter
} from "@/models/response/PulldownResponse";
import { CodeKbnList } from "@/models/codeMaster/Code";
import { DateTime } from "luxon";
import { Messages } from "@/message";
import { useApi } from "@/plugins/api/api";
import Attendance from "@/models/Attendance";

type Valid = typeof Valid[keyof typeof Valid];

type Props = {
  value: OverworkFlowDat;
  time?: string;
};
type Emits = {
  (e: "input", value: OverworkFlowDat): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'OvertimeWorkForm',
  props: {
    value: null,
    time: null
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "input", value: OverworkFlowDat): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: OverworkFlowDat;
  time?: string;
};

const { Paths, $get } = useApi();

const Valid = {
  On: "1",
  Off: "0"
} as const;
const segmentItems = [
  { text: "残業あり", value: Valid.On },
  { text: "残業なし", value: Valid.Off }
] as const;



const unixEndTime = ref<string>();

const reasonList = ref<string[]>([]);

const modelValue = computed({
  get: () => props.value,
  set: value => emits("input", value)
});

const segment = computed({
  get: () => segmentItems.findIndex(e => e.value === props.value.isOverwork),
  set: value => (modelValue.value.isOverwork = segmentItems[value].value)
});

const getEndUnixTime = async (shiftId: string) => {
  const path = `${Paths.approval.overtimeWork.endUnixTime}/${shiftId}`;
  return await $get<string>(path);
};

watch(segment, async () => {
  console.log("modelValue", props.value);
  modelValue.value.isNightShift = 0;
  modelValue.value.overtimeWorkBreak = "00:00";
  modelValue.value.overtimeWorkEnd = undefined;
  modelValue.value.reason = undefined;
  const id = props.value.shiftId ? props.value.shiftId : undefined;
  console.log("id", id);
  if (id != undefined) {
    unixEndTime.value = await getEndUnixTime(id);
    console.log("unixEndTime.value", unixEndTime.value);
    modelValue.value.endTimeStamp = unixEndTime.value;
  } else {
    modelValue.value.endTimeStamp = "";
  }
});

const overtimeRule = computed(() => {
  const from = props.value.overtimeWorkEnd;
  const to = props.time;
  if (from && to) {
    const a = DateTime.fromISO(from);
    const b = DateTime.fromISO(to);
    if (a.isValid && b.isValid) {
      return a > b || `${to}よりも遅い時間を選択してください。`;
    }
  }
  return true;
});

const breakTime = ref<DateTime>();

const breakTimeRules = computed(() => {
  const to = breakTime.value;
  const overtimeWorkBreak = props.value.overtimeWorkBreak;

  const from = overtimeWorkBreak
    ? DateTime.fromISO(overtimeWorkBreak)
    : undefined;

  if (from?.isValid && to?.isValid) {
    const time = to.toFormat("HH時mm分");
    return from.equals(to) || `休憩時間を${time}で登録してください。`;
  }
  return true;
});

const getBreakTime = async (shiftId: string) => {
  const path = `${Paths.approval.overtimeWork.breakTime}/${shiftId}`;
  return await $get<string>(path);
};

watch(
  () => props.value.shiftId,
  async val => {
    if (val) {
      const time = await getBreakTime(val);
      breakTime.value = time ? DateTime.fromISO(time) : undefined;
    }
  },
  { immediate: true }
);

const getCodeMaster = async () => {
  const code = await $get<PulldownResponse[]>(Paths.codeMasterPulldown);
  if (code) {
    reasonList.value = codeKbnFilter(code, CodeKbnList.OVRSN).map(e => e.name);
  }
};

onMounted(async () => {
  await getCodeMaster();
});

return { __sfc: true,Paths, $get, Valid, segmentItems, props, emits, unixEndTime, reasonList, modelValue, segment, getEndUnixTime, overtimeRule, breakTime, breakTimeRules, getBreakTime, getCodeMaster, VRow, VCol, VSelect, InputRules, TimePicker2, Messages }
}

})